module.exports = __webpack_public_path__ + "files/428b753db465ec9c3b8f35fccac50c5e.png";